import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import Artwork from '../FullScreenCarouselItem';
import NavBar from '../NavBar';

import SelectedPlaylistCarousel from '../SelectedPlaylistCarousel';
import './freemium-full-screen-carousel.scss';
import { setMuteFlag, fireAnalytics } from '../../pages/utils.js';
import { fetchActivePlaylist } from '../../store/actions/playlistActions';
import { fetchMobileQueue } from '../../store/actions/mobileActions';
import { ENTER, BACK, LEFT, UP, RIGHT, DOWN, EXIT } from '../../util/remoteButtons';
import { current } from '../../store/actions/appActions';
import { VERSION } from '../../pages/utils';

export class FreemiumCarousel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      current: props.selectedArtwork,
      navTimeout: null,
      navigating: false,
      showNav: false,
      nxtLoad: false,
      others: false,
      artworks: props.artworks,
      show: true,
      activeComponent: false,
      myPlaylistComponent: false,
      followedComponent: false,
      currentPlaylist: 0,
      selectedPlaylistId: props.selectedPlaylistId,
      selectedPlaylist: null,
      open: false,
      lastMobileUpdate: null,
      selectedButton: 'view',
      navBar: false,
      errorPopup: false,
      helpPopup: false
    };

    this.fsTimeout = null;
    this.getCurrentArtworkArtistName = this.getCurrentArtworkArtistName.bind(this);
    this.getCurrentArtworkName = this.getCurrentArtworkName.bind(this);
    this.updateOnlineStatus = this.updateOnlineStatus.bind(this);
    this.setArtworkInterval = this.setArtworkInterval.bind(this);
    this.k = 1;
    this.artworkInterval = 300000;
    this.artworkIntervalTime = null;
    this.updatePlaylist = true;
    this.mergeMyPlaylist = this.mergeMyPlaylist.bind(this);
    this.hideArtworkNameTimeout = null;
    this.selectedBtn = 'No';
    this.onlineStatusInterval = null;
    this.errorMessage = '';
  }

  async componentWillMount() {
    const artworkPosition = await this.getIndexOfSelectedArtwork(this.props.artworks);
    if (artworkPosition !== undefined) this.setState({ current: artworkPosition });
  }

  getIndexOfSelectedArtwork(artworks) {
    for (let i = 0; i < artworks.length; i++) {
      if (artworks[i].id === this.props.app.current) {
        return i;
      }
    }
  }

  componentDidMount() {
    fireAnalytics("Page", "Player Page Loaded");
    window.onkeydown = (e) => {
      if (this.state.navigating) {
        switch (e.keyCode) {
          case ENTER: {
            if (this.state.open) {
              setTimeout(() => {
                const { no } = this.refs;
                no.focus();
              }, 300);

              if (this.selectedBtn === 'No') {
                this.setState({ open: false });
                setTimeout(() => {
                  const { mainDiv } = this.refs;
                  mainDiv.focus();
                }, 700);
              }
              if (this.selectedBtn === 'Yes') {
                window.open("", "_self").close();
              }
            } else {
              switch (this.state.selectedButton) {
                case 'account': {
                  this.props.history.push('/Account');
                  break;
                }
                case 'upgrade': {
                  this.props.history.push('/Pair');
                  break;
                }
                default:
                  this.setState((prevState) => ({ ...prevState, navigating: false, navTimeout: null }));
                  break;
              }
            }
            break;
          }
          case LEFT: {
            if (this.state.open) {
              document.getElementById('yes').style.background = '';
              document.getElementById('No').style.background = '#910048';
              setTimeout(() => {
                const { no } = this.refs;
                no.focus();
              }, 300);
              this.selectedBtn = 'No';
            } else {
              clearTimeout(this.state.navTimeout);
              if (!this.state.activeComponent) {
                this.prevHandle();
              }
            }

            break;
          }
          case RIGHT: {
            if (this.state.open) {
              document.getElementById('No').style.background = '';
              document.getElementById('yes').style.background =
                '#910048';
              setTimeout(() => {
                const { yes } = this.refs;
                yes.focus();
              }, 300);
              // this.refs.yes.focus();
              this.selectedBtn = 'Yes';
            } else {
              clearTimeout(this.state.navTimeout);
              if (!this.state.activeComponent) {
                this.nextHandle();
              }
            }
            break;
          }
          case UP: {
            if (!this.state.open) {
              clearTimeout(this.state.navTimeout);
              const navTimeout = setTimeout(() => {
                this.setState((prevState) => ({ ...prevState, navigating: false }));
              }, 4000);
              if (this.state.navBar) {
                this.setState(() => ({ navBar: false }));
              }
              else {
                this.setState(() => ({ navBar: true }));
                setTimeout(() => {
                  const { upgrade } = this.refs;
                  upgrade.focus();
                }, 300);
              }
              // if (this.props.hasSubscription) {
              //   this.setState((prevState) => ({ ...prevState, selectedButton: 'account', navTimeout }));
              //   setTimeout(() => {
              //     const { accountButton } = this.refs;
              //     accountButton.focus();
              //   }, 300);
              // } else {
              //   this.setState((prevState) => ({ ...prevState, selectedButton: 'upgrade', navTimeout }));
              //   setTimeout(() => {
              //     const { upgrade } = this.refs;
              //     upgrade.focus();
              //   }, 300);
              // }
              break;
            }
          }
          case 27:
          case BACK: {
            setTimeout(() => {
              const { no } = this.refs;
              no.focus();
            }, 200);
            this.setState({ open: !this.state.open });
            break;
          }
          case EXIT: {
            setTimeout(() => {
              const { no } = this.refs;
              no.focus();
            }, 700);
            this.setState({ open: !this.state.open });
            break;
          }
          default:
            break;
        }
      } else if (this.state.navBar) {
        const { navBarChild } = this.refs;
        switch (e.which) {
          case RIGHT:
            if ((this.selectedBtn === "Pair" || this.selectedBtn === "Account") && this.props.hasSubscription) {
              navBarChild.refs.settings.focus();
              this.selectedBtn = "Settings";
              if (this.props.hasSubscription)
                document.getElementById("account").classList.remove("active");
              else
                document.getElementById("pair").classList.remove("active");
              document.getElementById("settings").classList.add("active");
            } else if (this.selectedBtn === "Settings") {
              navBarChild.refs.help.focus();
              this.selectedBtn = "Help";
              document.getElementById("settings").classList.remove("active");
              document.getElementById("help").classList.add("active");
            }
            else {
              const { navBarChild } = this.refs;
              navBarChild.refs.help.focus();
              this.selectedBtn = "Help";
              document.getElementById("pair").classList.remove("active");
              document.getElementById("help").classList.add("active");
            }
            break;
          case LEFT:
            // const { navBarChild } = this.refs;
            if (this.selectedBtn === "Help" && this.props.hasSubscription) {
              navBarChild.refs.settings.focus();
              this.selectedBtn = "Settings";
              document.getElementById("help").classList.remove("active");
              document.getElementById("settings").classList.add("active");
            } else if (this.selectedBtn === "Settings") {
              if (this.props.hasSubscription) {
                navBarChild.refs.account.focus();
                this.selectedBtn = "Account";
                document.getElementById("settings").classList.remove("active");
                document.getElementById("account").classList.add("active");
              }
              else {
                navBarChild.refs.pair.focus();
                this.selectedBtn = "Pair";
                document.getElementById("settings").classList.remove("active");
                document.getElementById("pair").classList.add("active");
              }
            }
            else {
              navBarChild.refs.pair.focus();
              this.selectedBtn = "Pair";
              document.getElementById("help").classList.remove("active");
              document.getElementById("pair").classList.add("active");
            }
            break;
          case ENTER:
            if (this.selectedBtn === 'Account') {
              this.selectedBtn = 'None';
              this.props.history.push('/Account');
            } else if (this.selectedBtn === 'Pair') {
              this.selectedBtn = 'None';
              this.props.history.push('/Pair');
            } else if (this.selectedBtn === 'Settings') {
              this.selectedBtn = 'None';
              this.props.history.push('/Settings');
            } else if (this.selectedBtn === 'Help') {
              this.selectedBtn = 'None';
              this.setState({ navBar: false });
              this.setState({ helpPopup: true });
            }
            break;
          case UP:
            this.setState({ navBar: false });
            break;
          case 27:
          case BACK:
            this.setState({ navBar: false });
            break;
        }
      } else if (this.state.helpPopup) {
        this.setState({ helpPopup: false });
      } else if ((e.keyCode === LEFT || e.keyCode === RIGHT) && !this.state.activeComponent && !this.state.myPlaylistComponent && !this.state.followedComponent && !this.state.navBar) {
        if (this.state.open && e.keyCode === LEFT) {
          document.getElementById('yes').style.background = '';
          document.getElementById('No').style.background = '#910048';
          setTimeout(() => {
            const { no } = this.refs;
            no.focus();
          }, 200);
          // this.refs.no.focus();
          this.selectedBtn = 'No';
        } else if (this.state.open && e.keyCode === RIGHT) {
          document.getElementById('No').style.background = '';
          document.getElementById('yes').style.background = '#910048';
          setTimeout(() => {
            const { yes } = this.refs;
            yes.focus();
          }, 200);
          // this.refs.yes.focus();
          this.selectedBtn = 'Yes';
        } else {
          clearTimeout(this.state.navTimeout);
          const navTimeout = setTimeout(() => {
            this.setState((prevState) => ({ ...prevState, navigating: false }));
          }, 4000);
          this.setState((prevState) => ({ ...prevState, navigating: true, navTimeout }));
        }
      } else if (e.keyCode === DOWN) {
        if (!this.state.open) {
          if (this.state.myPlaylistComponent && this.props.hasSubscription) {
            if (this.props.followedCollection.data.length > 0) {
              this.setState(() => ({ followedComponent: true }));
              this.setState(() => ({ myPlaylistComponent: false }));
              setTimeout(() => {
                const { followedCollectionChild } = this.refs;
                followedCollectionChild.refs.carousel.focus();
              }, 300);
            }
          } else if (this.state.activeComponent && this.props.hasSubscription) {
            if (this.props.myPlaylist.data.length > 0) {
              this.setState(() => ({ myPlaylistComponent: true }));
              this.setState(() => ({ activeComponent: false }));
              setTimeout(() => {
                const { myPlaylistChild } = this.refs;
                myPlaylistChild.refs.carousel.focus();
              }, 300);
            } else if (this.props.followedCollection.data.length > 0) {
              this.setState(() => ({ followedComponent: true }));
              this.setState(() => ({ activeComponent: false }));
              setTimeout(() => {
                const { followedCollectionChild } = this.refs;
                followedCollectionChild.refs.carousel.focus();
              }, 300);
            }
          } else if (this.state.activeComponent) {
            this.setState(() => ({ activeComponent: false }));
          } else {
            this.setState(() => ({ activeComponent: true }));
            if (this.props.hasSubscription) {
              setTimeout(() => {
                const { playlistChild } = this.refs;
                playlistChild.refs.carousel.focus();
              }, 300);
            }
          }
        }
      } else if (e.keyCode === BACK || e.keyCode === 27) {
        if (this.state.activeComponent) {
          this.setState(() => ({ activeComponent: false }));
        } else if (this.state.myPlaylistComponent) {
          this.setState(() => ({ myPlaylistComponent: false }));
        } else {
          setTimeout(() => {
            const { no } = this.refs;
            no.focus();
          }, 700);
          this.setState({ open: !this.state.open });
        }
      } else if (e.keyCode === EXIT) {
        setTimeout(() => {
          const { no } = this.refs;
          no.focus();
        }, 700);
        this.setState({ open: !this.state.open });
      } else if (e.keyCode === UP) {
        if (this.state.followedComponent) {
          if (this.props.myPlaylist.data.length > 0) {
            this.setState(() => ({ myPlaylistComponent: true }));
            this.setState(() => ({ followedComponent: false }));
            setTimeout(() => {
              const { myPlaylistChild } = this.refs;
              myPlaylistChild.refs.carousel.focus();
            }, 300);
          }
          else {
            this.setState(() => ({ activeComponent: true }));
            this.setState(() => ({ followedComponent: false }));
            setTimeout(() => {
              const { playlistChild } = this.refs;
              playlistChild.refs.carousel.focus();
            }, 300);
          }
        } else if (this.state.myPlaylistComponent) {
          this.setState(() => ({ activeComponent: true }));
          this.setState(() => ({ myPlaylistComponent: false }));
          setTimeout(() => {
            const { playlistChild } = this.refs;
            playlistChild.refs.carousel.focus();
          }, 300);
        } else if (this.state.activeComponent) {
          this.setState(() => ({ activeComponent: false }));
        } else if (!this.state.navBar) {
          this.setState((prevState) => ({ ...prevState, selectedButton: 'navBar' }));
          setTimeout(() => {
            const { navBarChild } = this.refs;
            navBarChild.refs.account.focus();
          }, 300);
          this.setState({ navBar: !this.state.navBar });
          if (this.props.hasSubscription) {
            this.selectedBtn = "Account";
          } else {
            this.selectedBtn = "Pair";
          }
        } else {
          this.setState({ navBar: !this.state.navBar });
        }
      } else if (e.keyCode === ENTER) {
        if (this.state.open) {
          if (this.selectedBtn === 'No') {
            this.setState({ open: false });
            setTimeout(() => {
              const { mainDiv } = this.refs;
              mainDiv.focus();
            }, 700);
          }
          if (this.selectedBtn === 'Yes') {
            window.open("", "_self").close();
          }
        }
      }
    };
    if (this.props.hasSubscription) {
      this.interval = setInterval(() => this.FetchFromMobile(), 5000);
      // this.mergeMyPlaylist();
    } else {
      this.artworkIntervalTime = setInterval(() => this.nextHandle(), this.artworkInterval);
    }
    window.addEventListener('online', this.updateOnlineStatus);
    window.addEventListener('offline', this.updateOnlineStatus);
  }

  updateOnlineStatus(event) {
    if (event.type == "offline") {
      fireAnalytics("Network", "Network Offline", event.type);
      this.onlineStatusTimer = this.onlineStatusTimer + 1;
      if (this.onlineStatusTimer <= 5) {
        this.errorMessage = "No Internet Connection"
        this.setState({ errorPopup: true });
        setTimeout(() => {
          this.setState({ errorPopup: false });
        }, 3000);
      } else {
        this.props.history.push(`/error`);
      }
    } else if (event.type == "online") {
      fireAnalytics("Network", "Network Online", event.type);
      this.onlineStatusTimer = 0;
    }
  }

  mergeMyPlaylist() {
    const { length } = this.props.myPlaylist.data;
    if (length > 0) {
      for (let i = 0; i < length; i++) {
        if (this.props.myPlaylist.data[i].artworks.length > 0) {
          this.props.homePlaylist.data.push(this.props.myPlaylist.data[i]);
        }
      }
    }
  }

  setArtworkInterval(interval) {
    if (interval === 0) {
      this.artworkInterval = interval;
      clearInterval(this.artworkIntervalTime);
    } else {
      clearInterval(this.artworkIntervalTime);
      this.artworkInterval = interval;
      this.artworkIntervalTime = setInterval(() => {
        this.k = 1;
        setTimeout(() => {
          this.nextHandle();
        }, 800);
      }, this.artworkInterval);
    }
  }

  async FetchFromMobile() {
    try {
      if (this.props.hasSubscription) {
        const result = await this.props.fetchMobileQueue(this.props.device.data.uid);
        if (result.errors === 'Error') {
          setTimeout(() => {
            this.props.history.push('/error');
          }, 10);
          return;
        }
        if (result.errors === 'Device Unregistered') {
          this.props.history.push('/');
          return;
        }
        if (this.props.app.mobileId.localeCompare(result.payload.device._embedded.user.id) !== 0) {
          this.props.history.push('/');
          return;
        }
        if (result.type === 'FETCH_MOBILE_QUEUE_SUCCESS') {
          setMuteFlag(this.props.mobileQueue.data.device.mute);
          if (this.state.lastMobileUpdate === null) {
            this.setState({ lastMobileUpdate: result.payload.updatedAt });
          }
          if (this.artworkInterval !== this.props.mobileQueue.data.device.interval) {
            this.setArtworkInterval(this.props.mobileQueue.data.device.interval);
          }
          if (this.props.mobileQueue.data.updatedAt !== this.state.lastMobileUpdate) {
            this.setState({ lastMobileUpdate: result.payload.updatedAt });
            if (result.payload.queue.artworks.length <= 0) {
              this.errorMessage = "Unable to play the Selected Artwork."
              this.setState({ errorPopup: true });
              setTimeout(() => {
                this.setState({ errorPopup: false });
              }, 3000);
              return;
            }
            const { artworks } = result.payload.queue;
            this.setState({
              artworks,
              current: 0
            })
            this.setState({ activeComponent: false });
            clearInterval(this.artworkIntervalTime);
            this.artworkInterval = null;
            this.updatePlaylist = false;
            const activePlaylist = this.props.fetchActivePlaylist(result.payload.queue.id);
            if (activePlaylist.errors === 'Error') {
              setTimeout(() => {
                this.props.history.push('/error');
              }, 10);
              return;
            }
            fireAnalytics('Playlist', 'Selected New Playlist From Mobile', result.payload.queue.id);
          }
        }
      }
    }
    catch (err) {
      console.log(err);
    }
  }

  async getArtworkFromPlaylist(id) {
    if (this.state.activeComponent || this.state.myPlaylistComponent || this.state.followedComponent) {
      this.updatePlaylist = true;
      // this.props.hasSubscription ?
      const activePlaylist = await this.props.fetchActivePlaylist(id);
      if (activePlaylist.errors === 'No Artworks' || activePlaylist.errors === 'Error') {
        this.errorMessage = "No artworks in Collection"
        this.setState({ activeComponent: false, myPlaylistComponent: false, followedComponent: false });
        this.setState({ errorPopup: true });
        setTimeout(() => {
          this.setState({ errorPopup: false });
        }, 3000);
        this.updatePlaylist = false;
      } else {
        fireAnalytics('Playlist', 'Selected New Playlist', id);
      }
    }
    // this.props.history.push('/Pair');
  }

  async setCurrent(pid) {
    this.props.homePlaylist.data.filter((data, idx) => {
      if (data.playlistId === pid) {
        this.setState({ currentPlaylist: idx });
      }
    });
  }

  async setCurrentArtworkId(id) {
    this.props.current(id);
  }

  async setExitApp() {
    this.setState({ open: !this.state.open });
  }

  prevHandle() {
    clearTimeout(this.state.navTimeout);
    const slides = this.state.artworks.slice(0);
    slides.unshift(slides.pop());

    const navTimeout = setTimeout(() => {
      this.setState((prevState) => ({ ...prevState, navigating: false }));
    }, 4000);

    this.setState((prevState) => ({
      ...prevState,
      navTimeout,
      artworks: slides,
    }));
  }

  nextHandle() {
    clearTimeout(this.state.navTimeout);
    const newArray = this.state.artworks.slice(0);
    newArray.push(newArray.shift());
    const navTimeout = setTimeout(() => {
      this.setState((prevState) => ({ ...prevState, navigating: false }));
    }, 4000);
    this.setState((prevState) => ({ ...prevState, navTimeout, artworks: newArray }));
  }

  getCurrentArtworkName() {
    const { artworks } = this.state;
    if (!artworks || artworks.length == 0) return '';

    return artworks[this.state.current].name;
  }

  getCurrentArtworkArtistName() {
    const { artworks } = this.state;
    if (!artworks || artworks.length == 0) return '';

    const { current } = this.state;

    return `${artworks[current]._embedded.artist.givenName} ${artworks[current]._embedded.artist.surname}`;
  }

  async onNavigation(navTo) {
    if (navTo === 'Hide') {
      setTimeout(() => {
        const { mainDiv } = this.refs;
        mainDiv.focus();
      }, 300);
    } else if(navTo === 'Help') {
      this.selectedBtn = 'None';
      this.setState({ navBar: false });
      this.setState({ helpPopup: true });
    }
    else {
      this.selectedBtn = 'None';
      this.props.history.push("/" + navTo);
    }
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  componentWillReceiveProps(nextProps) {
    if ((nextProps.selectedPlaylistId !== this.state.selectedPlaylistId) && this.updatePlaylist) {
      const { artworks } = nextProps;
      this.setState({
        artworks,
        current: 0,
        selectedPlaylistId: nextProps.selectedPlaylistId
      });
      clearInterval(this.artworkIntervalTime);
      this.setArtworkInterval(this.props.mobileQueue.data.device.interval);
      this.setState({ activeComponent: false, myPlaylistComponent: false, followedComponent: false });
    }
  }

  render() {
    const { current, showNav, artworks } = this.state;
    const slideWidth = 100;
    let left = (-current * slideWidth) - 100;
    const slides = artworks.map((item, idx) => {
      left += slideWidth;
      if (idx === current) {
        return (
          <div key={idx} className="freemium-full-screen-carousel__slide" style={{ left: `${left}%` }}>
            <Artwork isCurrent={idx == current} artwork={item} hasSubscription={this.props.hasSubscription} history={this.props.history} setCurrentArtworkId={(item) => this.setCurrentArtworkId(item)} currentId={item.id} />
          </div>
        );
      }
    });

    return (
      <div className="fullscreenFreemiumWrapper" ref="mainDiv">
        {
          this.state.navBar ? <NavBar ref="navBarChild" subscription={this.props.hasSubscription} deviceId={this.props.device} onNavigation={(navTo) => this.onNavigation(navTo)} /> : null
        }
        {slides}
        {
          this.state.open ? (
            <div id="models" className="reg-response-modal" style={{ position: 'absolute', zIndex: '9999' }}>
              <div className="model" style={{ width: '40%', backgroundColor: 'black', color: 'white', borderRadius: '15px' }}>
                <img className="Logo2" src="/assets/img/blackdove-logo-2020.png" alt="" style={{ width: '50%', paddingTop: '6%' }} />
                <h2 style={{ marginBottom: '2%' }}>Do you want to exit?</h2>
                <button
                  ref="no"
                  id="No"
                  onClick={() => {
                    this.setState({ open: false });
                  }}
                  style={{ background: '#910048' }}
                  className="exitPopup"
                >No
                </button>
                <button
                  ref="yes"
                  id="yes"
                  style={{ marginLeft: '2%' }}
                  className="exitPopup"
                  onClick={() => {
                    window.open("", "_self").close();
                  }}
                >Yes
                </button>
              </div>
            </div>
          ) : null
        }
        {
          this.state.helpPopup ? (
            <div id="models" className="reg-response-modal" style={{ position: 'absolute', zIndex: '9999' }}>
              <div className="model" style={{ width: '40%', backgroundColor: 'black', color: 'white', borderRadius: '15px' }}>
                <img className="Logo2" src="/assets/img/blackdove-logo-2020.png" alt="" style={{ width: '50%', paddingTop: '6%' }} />
                <h2 style={{ marginBottom: '2%', fontSize: '2em' }}>Need some help? Send us an email to support@blackdove.com</h2>
                <button
                  ref="no"
                  id="No"
                  style={{ background: '#910048' }}
                  className="helpPopup"
                  onClick={() => {
                    this.setState({ helpPopup: false });
                  }}
                >OK
                </button>
                <p>App Version: {VERSION}</p>
              </div>
            </div>
          ) : null
        }
        {this.state.navigating && (
          <div className="fullscreenNavOverlay">
            <div
              onClick={() => { this.prevHandle(); }}
              className="btn btn--circle navLeft"
            ><span tabIndex="2" ref="previous" className="ion-ios-arrow-back btn--arrow" />
            </div>
            <div
              onClick={() => { this.nextHandle(); this.k = 1; }}
              className="btn btn--circle navRight"
            >
              <span ref="next" tabIndex="3" className="ion-ios-arrow-forward btn--arrow" />
            </div>
          </div>
        )}
        {
          (this.state.activeComponent && !this.props.hasSubscription) ? (
            <div className="PlaylistSelector" style={(this.state.activeComponent && !this.props.hasSubscription) ? { bottom: '0' } : { bottom: '-36%' }}>
              <img src="/assets/img/CollectionItems.png" alt="dummy collections" style={{ height: '100%', width: '100%' }} />
              <div className="NotSubscribed-Text">Please Subscribe or Purchase an artwork to access Collections.</div>
            </div>
          )
            : null
        }
        {
          // (this.state.activeComponent && this.props.hasSubscription) ? (
          <div className="PlaylistSelector" style={(this.state.activeComponent && this.props.hasSubscription) ? { bottom: '0' } : { bottom: '-36%' }}>
            <SelectedPlaylistCarousel
              ref="playlistChild"
              playlist={this.props.homePlaylist.data}
              currentPlaylist={this.state.currentPlaylist}
              subscription={this.props.hasSubscription}
              history={this.props.history}
              dispatch={this.props.dispatch}
              getArtworkFromPlaylist={(pid) => this.getArtworkFromPlaylist(pid)}
              setCurrent={(pid) => this.setCurrent(pid)}
              onExitApp={() => this.setExitApp()}
            />
          </div>
          // )
          //   : null
        }
        {
          (this.state.myPlaylistComponent && this.props.hasSubscription) ? (
            <div className="PlaylistSelector" style={{ zIndex: '40' }}>
              <SelectedPlaylistCarousel
                ref="myPlaylistChild"
                playlist={this.props.myPlaylist.data}
                currentPlaylist={0}
                subscription={this.props.hasSubscription}
                history={this.props.history}
                dispatch={this.props.dispatch}
                getArtworkFromPlaylist={(pid) => this.getArtworkFromPlaylist(pid)}
                setCurrent={(pid) => this.setCurrent(pid)}
                onExitApp={() => this.setExitApp()}
              />
            </div>
          )
            : null
        }
        {
          (this.state.followedComponent && this.props.hasSubscription) ? (
            <div className="PlaylistSelector">
              <SelectedPlaylistCarousel
                ref="followedCollectionChild"
                playlist={this.props.followedCollection.data}
                currentPlaylist={0}
                subscription={this.props.hasSubscription}
                history={this.props.history}
                dispatch={this.props.dispatch}
                getArtworkFromPlaylist={(pid) => this.getArtworkFromPlaylist(pid)}
                setCurrent={(pid) => this.setCurrent(pid)}
                onExitApp={() => this.setExitApp()}
              />
            </div>
          )
            : null
        }
        {
          // this.state.activeComponent ? (
          <div className="collection-title" style={this.state.activeComponent ? { bottom: '0' } : { bottom: '-36%' }}>
            <div className="collection-title-name">
              Featured Collections
              {((this.props.myPlaylist.data.length > 0 || this.props.followedCollection.data.length > 0) && this.props.hasSubscription) ? <img src="/assets/img/down.png" className="collection-title-name-downImg" /> : null}
            </div>
          </div>
          // )
          // : null
        }
        {
          this.state.myPlaylistComponent ? (
            <div className="collection-title">
              <div className="collection-title-name">
                Your Collections
                <img src="/assets/img/up.png" className="collection-title-name-upImg" />
                {this.props.followedCollection.data.length > 0 ? <img src="/assets/img/down.png" className="collection-title-name-downImg" /> : null}
              </div>
            </div>)
            : null
        }
        {
          this.state.followedComponent ? (
            <div className="collection-title">
              <div className="collection-title-name">
                Followed Collections
                <img src="/assets/img/up.png" className="collection-title-name-upImg" />
              </div>
            </div>)
            : null
        }
        <div className="timedPopup" style={!this.state.errorPopup ? { opacity: '0' } : { opacity: '1' }} >{this.errorMessage}</div>
      </div>

    );
  }
}
const mapDispatchToProps = (dispatch) => ({
  fetchActivePlaylist: (targetPlaylistId) => dispatch(fetchActivePlaylist(targetPlaylistId)),
  fetchMobileQueue: (deviceId) => dispatch(fetchMobileQueue(deviceId)),
  current: (id) => dispatch(current(id)),
});

export default connect((state) => {
  const { homePlaylist, userPlaylists, myPlaylist, followedCollection, device, mobileQueue, app } = state;
  return {
    app,
    userPlaylists,
    homePlaylist,
    myPlaylist,
    followedCollection,
    device,
    mobileQueue
  };
}, mapDispatchToProps)(FreemiumCarousel);
